import React from "react";
import { Container, Typography } from "@mui/material";

import Placeholder from "components/Placeholder";

import useStyles from "../useStyles";

const LoadingHeader = () => {
  const classes = useStyles();
  return (
    <Container data-testid="pageHeader-placeholder" className={classes.head}>
      <Typography className={classes.title} align="center" variant="h1">
        <Placeholder variant="text" width={350} />
      </Typography>
      <Typography className={classes.description} align="center" variant="large">
        <Placeholder variant="text" width={350} />
      </Typography>
    </Container>
  );
};

export default LoadingHeader;
